import { createContext, useContext, useState, type ReactNode } from 'react';

interface AccordionContextValue {
	openId: string | null;
	setOpenId: (id: string | null) => void;
}

const AccordionContext = createContext<AccordionContextValue | null>(null);

/**
 * Makes the direct FuseNavVerticalCollapse children of this provider mutually exclusive:
 * expanding one collapses any sibling that was previously open, keeping the sidebar short.
 */
export function AccordionProvider({ children, initialOpenId = null }: { children: ReactNode; initialOpenId?: string | null }) {
	const [openId, setOpenId] = useState<string | null>(initialOpenId);

	return <AccordionContext.Provider value={{ openId, setOpenId }}>{children}</AccordionContext.Provider>;
}

export function useAccordion() {
	return useContext(AccordionContext);
}
